import { render, staticRenderFns } from "./imgS.vue?vue&type=template&id=3745149a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3745149a')) {
      api.createRecord('3745149a', component.options)
    } else {
      api.reload('3745149a', component.options)
    }
    module.hot.accept("./imgS.vue?vue&type=template&id=3745149a", function () {
      api.rerender('3745149a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgS.vue"
export default component.exports